var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.136,
    height: 16,
    viewBox: "0 0 18.136 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27598",
    "data-name": "Path 27598",
    d: "M111.69,67.129a2.169,2.169,0,0,1,.261,1.891,2.873,2.873,0,0,0,.516,2.733,3.125,3.125,0,0,1,.621-.551,2.051,2.051,0,0,1-.336-1.96,2.848,2.848,0,0,0-2.778-3.774l-.037.83a2.185,2.185,0,0,1,1.753.83Zm8.557-2.766c-2.806-.359-4.779,1.254-4.974,3.751-.2,2.615.687,3.413,1.427,3.7a8.8,8.8,0,0,0,1.272.347,8.129,8.129,0,0,0-2.807.939s-.332.263-.53.073a.3.3,0,0,1,.063-.463,4.078,4.078,0,0,1,1.144-.639,2.584,2.584,0,0,1-.852-1.1,4.372,4.372,0,0,0-2.47,1.767,1.72,1.72,0,0,0,0,1.97c.706.84,2.779,1,5.157.4a.312.312,0,0,1,.153.6,11.9,11.9,0,0,1-2.84.382,5.442,5.442,0,0,1-1.974-.317,3.218,3.218,0,0,1-.067.712.342.342,0,0,1-.32.3.3.3,0,0,1-.3-.3,1.062,1.062,0,0,1,.014-.129,2.6,2.6,0,0,0,.021-.95,2.069,2.069,0,0,1-.316-.3c-.376-.447-.858-1.52.128-3.066-.835-1.073-2.535-1-3.975.285a3.43,3.43,0,0,0-.5.531.326.326,0,0,1-.418.064c-.221-.136-.108-.4-.052-.481a3.11,3.11,0,0,1,.691-.687c-.831-1.086-2.616-.055-2.362,2.3.108,1.007.927,1.887,2.748,1.384,0,0,.061-.286.082-.381a4.588,4.588,0,0,1,.672-1.391.31.31,0,0,1,.461-.063.3.3,0,0,1,.056.411,4.1,4.1,0,0,0-.582,1.183,4.3,4.3,0,0,0,1.083,4.235c2.773,2.609,11.349-1.015,12.073-5.417.235-1.424-.138-1.332.675-2.8,1.942-3.5.3-6.493-2.57-6.859Z",
    transform: "translate(-105.525 -64.314)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.5614eeb73aa01ae61a41a3138c499f7e.svg";
export { ForwardRef as ReactComponent };